import { VideoOff } from "lucide-react";
import React, { forwardRef } from "react";

export default forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  function CameraArea(props, ref) {
    return (
      <div
        ref={ref}
        {...props}
        className="w-full h-full bg-foreground dark:bg-foreground/50 rounded-lg overflow-hidden justify-center flex items-center "
      >
        <VideoOff className="text-gray-300" size={90} />
      </div>
    );
  }
);
